 <template>
  <div class="dashboard pt-12" >
    <v-container fluid class="grey darken-4 recolor" py-0 >
      <v-layout row wrap>
        <v-flex xs12 class="" :class="[$vuetify.breakpoint.mdAndUp ? 'split-bg' : '']">
          <v-container class="max-container" py-0 :class="[$vuetify.breakpoint.mdAndUp ? 'px-7' : '']">
            <v-layout
              fill-height
              row 
              wrap
              :class="[$vuetify.breakpoint.mdAndUp ? 'pt-12 mt-8' : '']"
            >
              <v-flex xs12 md6 lg4 ma-0 class="" :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'py-4']" order-md1 order-xs2>
                <v-card height="100%" color="transparent" class="elevation-0">
                  <v-container fluid fill-height py-0>
                    <v-layout row wrap align-center justify-end :class="[$vuetify.breakpoint.mdAndDown ? '' : '', $vuetify.breakpoint.lgAndUp ? '' : '']">
                      <v-flex xs12 md12  py-0  class=" white--text position-relative">
                        <v-container fluid py-0>
                          <v-layout row wrap>
                            <v-flex xs12 :class="[$vuetify.breakpoint.mdAndUp ? 'pr-2' : '']">
                              <v-item-group mandatory v-model="dataStatusModel" class="">
                                <v-container fluid py-0 :class="[$vuetify.breakpoint.mdAndUp ? '' : '']">
                                  <v-row class="justify-end">
                                    <v-col cols="12"  class="py-0" :class="[$vuetify.breakpoint.mdAndUp ? 'pl-0 pr-9' : '']">
                                      <span class="headline font-regular d-block" :class="[$vuetify.breakpoint.mdAndUp ? 'mb-2' : 'my-0']" >Data status</span>
                                    </v-col>
                                  </v-row>
                                </v-container>
                                <v-container fluid py-6 class="">
                                  <div v-if="stateLoading"><span class="d-block mt-2"><v-icon class="font-30">fas fa-spinner fa-spin</v-icon><span class="primary--text font-weight-bold mx-2">De gegevens worden opgehaald</span></span></div>
                                  <v-row v-if="!stateLoading">
                                    <v-col
                                      v-for="(item, i) in dataStatus"
                                      :key="i"
                                      cols="12"
                                      md="12"
                                      class="pa-0"
                                    >
                                      <v-item v-slot:default="{ active, toggle }">
                                        <v-hover v-slot:default="{ hover }">
                                        <v-card
                                          :color="active ? 'grey darken-3 recolor' : ''"
                                          class="d-flex align-center energy-dates"
                                          dark
                                          :height="$vuetify.breakpoint.xsOnly ? 'auto' : '50'"
                                          @click="toggle(); selected(i);"
                                          tile
                                          :elevation="hover ? 2 : 0"
                                          :class="{ 'on-hover': hover }"
                                        > 
                                          <v-container fluid grid-list-lg>
                                            <v-layout row wrap align-center justify-end fill-height :class="['weekday-'+i]">
                                              <v-flex xs12 sm5>
                                                {{ toShortFullDate(item.date) }}
                                              </v-flex>
                                              <v-flex xs12 sm7 :class="[$vuetify.breakpoint.xsOnly ? 'pb-4' : '']">
                                                <v-card height="25" class="elevation-0 tile head-graph ma-0" color="transparent" :class="[$vuetify.breakpoint.smAndDown ? 'pl-1' : 'pr-10', $vuetify.breakpoint.mdOnly ? 'pr-6' : '']">
                                                  <bars-chart v-bind:data="item" style="border: 1px solid white; border-radius: 4px !important; padding: 2px;" class=""></bars-chart>
                                                </v-card>
                                              </v-flex>
                                            </v-layout>
                                          </v-container>
                                          <v-scroll-y-transition class="position-absolute">
                                            <div
                                              v-if="active"
                                              class="flex-grow-1 h-100 text-center position-relative"
                                              :class="[$vuetify.breakpoint.mdAndUp ? 'has-triangle triangle1' : '']"
                                            ></div>
                                          </v-scroll-y-transition>
                                        </v-card>
                                        </v-hover>
                                      </v-item>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-item-group>
                            </v-flex>
                          </v-layout>
                        </v-container>
                        <v-container fluid py-0 px-3  :class="[$vuetify.breakpoint.smAndDown ? 'pt-0 pb-2' : '']">
                          <v-layout row wrap  justify-end :class="[$vuetify.breakpoint.mdAndDown ? 'px-2' : 'pr-1', $vuetify.breakpoint.lgAndUp ? '' : '']" >
                            <v-flex xs12   class=" white--text position-relative">
                              <v-container fluid py-0 :class="[$vuetify.breakpoint.mdAndUp ? 'px-5' : 'px-4']"> 
                                <v-layout row wrap fill-height :class="[$vuetify.breakpoint.mdAndUp ? 'pr-12' : '']">
                                  <v-flex xs6 sm5>
                                    <a class="d-block dashboard-pager" v-bind:class="{ 'can-press': current }" @click="switchStates(false)">< vorige week</a>
                                  </v-flex>
                                  <v-flex xs6 sm7>
                                    <v-layout row wrap justify-end pr-4>
                                      <a class="d-block dashboard-pager" v-bind:class="{ 'can-press': !current }" @click="switchStates(true)">huidige week ></a>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex> 
              <v-flex xs12 md6 lg8 ma-0 class="grey darken-3 recolor " :class="[$vuetify.breakpoint.mdAndUp ? ' py-12' : 'pt-4 pb-2', $vuetify.breakpoint.mdOnly ? ' pl-8 pr-4' : '']" order-md2 order-xs1>
                <v-card height="100%" color="transparent" class="elevation-0">
                <v-container fluid fill-height :class="[$vuetify.breakpoint.smAndDown ? 'py-0' : '']">
                  <v-layout row wrap align-center justify-start>
                    <v-flex xs12  py-2 class=" white--text position-relative" >
                      <v-container fluid py-0 ma-0 :class="[$vuetify.breakpoint.smAndDown ? 'mt-4' : '']">
                        <v-layout row wrap align-center :class="[$vuetify.breakpoint.smAndDown ? 'px-5 py-4' : 'py-6']">
                          <v-flex xs12 lg5 xl6 :class="[$vuetify.breakpoint.mdAndUp ? '' : 'pb-2']" v-if="$vuetify.breakpoint.mdAndUp">
                            <v-card :height="$vuetify.breakpoint.lgAndDown ? '250' : '350'" class="elevation-0 tile head-graph pa-0" color="transparent" style="margin-top: -34px !important;" :class="[$vuetify.breakpoint.mdAndDown ? 'mb-6' : '']">
                              <div v-if="stateLoading">&nbsp;</div>
                              <pie-chart :data="requestStates" v-if="!stateLoading"></pie-chart>
                            </v-card>
                          </v-flex>
                          <div v-if="stateLoading"><span class="d-block mt-2"><v-icon class="font-30">fas fa-spinner fa-spin</v-icon><span class="primary--text font-weight-bold mx-2">De gegevens worden opgehaald</span></span></div>
                          <v-flex xs12 lg7 xl6 :class="[$vuetify.breakpoint.mdAndUp ? '' : '']" v-if="!stateLoading">
                            <v-card  class="dash-stat white-bor elevation-0 mb-4 no-bg">
                              <v-container fluid py-0 ma-0>
                                <v-layout row wrap>
                                  <v-flex xs4 sm6 md3>
                                    <div class="percentage-box stat-neg d-flex align-center justify-center">
                                      <span>{{ formatNumber(((selectedItem.errors.request + selectedItem.errors.malfunction) / (selectedItem.total != 0 ? selectedItem.total : 1)) * 100, 2) }}%</span>
                                    </div>
                                  </v-flex>
                                  <v-flex xs8 sm6 md9 pl-4 pr-2>
                                    <v-container fluid pa-0 ma-0>
                                      <v-layout row wrap align-center fill-height pa-2 pr-3>
                                        <v-flex xs12 class="bot-bor-white pb-2">
                                          <v-container fluid py-0>
                                            <v-layout row wrap align-center fill-height>
                                              <a class="w-100 d-flex stat-link" @click="toRequests({state:[3, 4]})">
                                                <span class="mr-auto">
                                                  {{ formatNumber(selectedItem.errors.request) }} fouten tijdens de aanvraag
                                                </span>
                                                <v-icon class="ml-2 d-block" >fas fa-chevron-right</v-icon>
                                              </a>
                                            </v-layout>
                                          </v-container>
                                        </v-flex>
                                        <v-flex xs12 pt-2>
                                          <v-container fluid py-0>
                                            <v-layout row wrap align-center fill-height>
                                              <a class="w-100 d-flex stat-link" @click="toRequests({state:[3, 6]})">
                                                <span class="mr-auto">
                                                  {{ formatNumber(selectedItem.errors.malfunction) }} fouten door storing
                                                </span>
                                                <v-icon class="d-block ml-2" >fas fa-chevron-right</v-icon>
                                              </a>
                                            </v-layout>
                                          </v-container>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                            <v-card class="dash-stat white-bor elevation-0 mb-4 no-bg">
                              <v-container fluid py-0 ma-0>
                                <v-layout row wrap>
                                  <v-flex xs4 sm6 md3>
                                    <div class="percentage-box stat-pos2 d-flex align-center justify-center">
                                      <span>{{ formatNumber(((selectedItem.expected) / (selectedItem.total != 0 ? selectedItem.total : 1)) * 100, 2) }}%</span>
                                    </div>
                                  </v-flex>
                                  <v-flex xs8 sm6 md9 pl-4 pr-2>
                                    <v-container fluid fill-height pa-0 ma-0>
                                      <v-layout row wrap align-center fill-height pa-2 pr-3>
                                        <v-flex xs12 >
                                          <v-container fluid py-0>
                                            <v-layout row wrap align-center fill-height>
                                              <a href="#" class="w-100 d-flex stat-link align-center" @click="toRequests({state:[2]})">
                                              <span class="mr-auto">
                                                Data in aanvraag voor<br />
                                                {{ formatNumber(selectedItem.expected) }} aansluitingen
                                              </span>
                                              <v-icon class="ml-2 big-chev d-block" >fas fa-chevron-right</v-icon>
                                              </a>
                                            </v-layout>
                                          </v-container>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                            <v-card class="dash-stat white-bor elevation-0 no-bg">
                              <v-container fluid py-0 ma-0>
                                <v-layout row wrap>
                                  <v-flex xs4 sm6 md3>
                                    <div class="percentage-box stat-pos1 d-flex align-center justify-center">
                                      <span>{{ formatNumber(((selectedItem.recieved) / (selectedItem.total != 0 ? selectedItem.total : 1)) * 100, 2) }}%</span>
                                    </div>
                                  </v-flex>
                                  <v-flex xs8 sm6 md9 pl-4 pr-2>
                                    <v-container fluid fill-height pa-0 ma-0>
                                      <v-layout row wrap align-center fill-height pa-2 pr-3>
                                        <v-flex xs12>
                                          <v-container fluid py-0>
                                            <v-layout row wrap align-center fill-height>
                                              <a class="w-100 d-flex stat-link align-center" @click="toRequests({state:[5]})">
                                                <span class="mr-auto">
                                                  Data ontvangen voor<br />
                                                  {{ formatNumber(selectedItem.recieved) }} aansluitingen
                                                </span>
                                                <v-icon class="ml-2 big-chev d-block" >fas fa-chevron-right</v-icon>
                                              </a>
                                            </v-layout>
                                          </v-container>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid black :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'px-0']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-0']">
        <v-layout row wrap :class="[$vuetify.breakpoint.mdAndUp ? 'px-4' : 'px-3']">
          <v-flex xs12>
            <s-card :title="pageContent.pageSub2">
              <v-data-table dark
                :headers="headers"
                :items="actions.data"
                :items-per-page="5"
                :loading="actionsLoading"
                loading-text="laden..."
                no-results-text="geen acties beschikbaar"
                no-data-text="geen acties beschikbaar"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :footer-props="{ itemsPerPageOptions: [5,10,15,20,50,100], itemsPerPageText: 'Rijen per pagina' }"
                :server-items-length="actions.recordsTotal"
                :options.sync="actionOptions"
                :class="[$vuetify.breakpoint.mdAndUp ? 'white-borders' : 'mobile-table']"
                dense
              >
                <template v-slot:item.date="{ item }">
                  {{ toDate(item.date) }}
                </template>
                <template v-slot:item.number="{ item }">
                  {{ item.number }} {{ item.addition }}
                </template>
                <template v-slot:item.priority="{ item }">
                  <span class="text-no-wrap d-flex" @click="openDialog(item)" style="cursor: pointer">
                      <v-icon v-if="item.priority === 'hoog'" small class="mr-2 color-neg ">fas fa-exclamation-circle</v-icon>
                      <span class="white--text no-dec mr-2">{{ item.priority }}</span>
                      <v-icon class="ml-auto small-icon" >fas fa-chevron-right</v-icon>
                  </span>
                </template>
              </v-data-table>
            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
   <action-modal :action="currentitem" :dialog.sync="showDialog" :dialog="showDialog" @actionUpdated="actionChanged"></action-modal>
  </div>
</template>

<script>

import PieChart from '@/components/PieChart';
import BarsChart from '@/components/BarsChart';
import ActionModal from '@/components/ActionModal';

export default {
  components: { PieChart, BarsChart, ActionModal },
  name: 'dashboard',
  data() {
    return {
      showDialog: false,
      currentitem:null,
      stateLoading: false,
      actionsLoading: false,
      current: true,
      pagination: {
        rowsPerPage: 30
      },
      actions:
      {
        data:[],
        recordsTotal:0,
        page:1
      },
      headers: [
        { text: 'Actie', value: 'label', align: 'left',},
        { text: 'Postcode', value: 'postal' },
        { text: 'Huisnr', value: 'number' },
        { text: 'EAN', value: 'ean' },
        { text: 'Type', value: 'type' },
        { text: 'Categorie', value: 'category' },
        { text: 'Datum', value: 'date' },
        { text: 'Prioriteit', value: 'priority' },
      ],
      dataStatus: [
      ],
      requestStates: [

      ],
      selectedItem:
      {
          date:null,
          errors:
          {
            request:0,
            malfunction:0
          },
          expected:0,
          recieved:0,
          total:0
      },
      dataStatusModel: 6,
      pageContent: {
        pageSub1: 'Data status',
        pageSub2: 'Actie vereist',
      },
      actionOptions:
      {
        filters:{state:1},
        sortBy:['priority'],
        sortDesc:[false]
      },
    };
  },
  created()
  {
    if(this.$store.getters.auth === false){
      this.$router.push({name: 'authentication'});
    }
  },
  mounted()
  {
    this.loadStates();
  },
  computed: 
  {

  },
  watch:
  {
    actionOptions: {
      deep:true,
          handler (newState, old) {
           this.loadActions();
      }
    }
	},
  methods: {
    openDialog(action)
    {
      this.currentitem = action;
      this.showDialog = true;
    },
    switchStates(current)
    {
      this.current = current;
      this.loadStates();
    },
    loadStates()
    {
      this.stateLoading = true;

      this.dataStatus = [];
      let start = new Date();
      let end = new Date();
      if(this.current)
      {
        start.setDate(start.getDate() - 7);
        end.setDate(end.getDate() - 1);
      }
      else
      {
        start.setDate(start.getDate() - 14);
        end.setDate(end.getDate() - 8);
      }
      let data = 
      {
        start:start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate(),
        end:end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate(),
      };
      this.$store.dispatch('loadDataState', data).then
      ((data) => {
        this.dataStatusModel = 6;
        this.dataStatus = data.data;
        this.stateLoading = false;
        this.selected(this.dataStatusModel);
      });
    },
    selected(index)
    {
      this.selectedItem = this.dataStatus[index];
      this.selectedItem.total = this.selectedItem.errors.request + this.selectedItem.errors.malfunction + this.selectedItem.expected + this.selectedItem.recieved;
      this.requestStates = 
      [
        {amount:this.selectedItem.errors.request + this.selectedItem.errors.malfunction, state:'error'},
        {amount:this.selectedItem.expected, state:'aangevraagd'},
        {amount:this.selectedItem.recieved, state:'ontvangen'}
      ];
    },
    loadActions()
    {
      this.actionsLoading = true;
      this.$store.dispatch('loadActions', this.actionOptions).then
      ((data) => {
        this.actions = data;
        this.actionsLoading = false;
      });
    },
    actionChanged(action)
    {
      this.showDialog = false;
      this.currentitem = action;
      this.showDialog = true;
      this.loadActions();
    }
  }
};
</script>

<style scoped>

.v-card.energy-dates {
    -moz-transition: all 200ms ease-in;
    -webkit-transition: all 200ms ease-in;
    -o-transition: all 200ms ease-in;
    transition: all 200ms ease-in;
}

.v-card.energy-dates:not(.on-hover):not(.v-item--active){
  background: #141414;
 }

.v-card.v-card--link:before{
  background: none;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>